// import logo from './logo.svg';
// import './App.css';
// import InteriorDesignWebsite from './Components/Home';

// function App() {
//   return (
//     <InteriorDesignWebsite/>
//   );
// }

// export default App;


// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './Components/Header';
import ScrollToTop from './Components/scrollToTop';

// Import your components
import InteriorDesignWebsite from './Components/Home';
import AboutPage from './Components/AboutPage';
import ServicesPage from './Components/ServicesPage';
import ContactPage from './Components/ContactPage';
// import PortfolioPage from './Components/Portfolio'; 

function App() {
  return (
    <Router>
       <ScrollToTop />
      <Header/>
      <Routes>
        <Route path="/" element={<InteriorDesignWebsite />} />
        {/* <Route path="/home" element={<InteriorDesignWebsite />} /> */}
        {/* 
      
        <Route path="/portfolio" element={<PortfolioPage />} /> */}
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        {/* Catch all route - redirect to home */}
        <Route path="*" element={<InteriorDesignWebsite />} />
      </Routes>
    </Router>
  );
}

export default App;